import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Bike, Store, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

export default function OrderTypeModal({ open, onClose }) {
  const { setOrderType } = useCart();
  const navigate = useNavigate();
  const choose = (type) => { setOrderType(type); onClose(); navigate("/menu"); };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md w-[95vw] rounded-3xl p-6 bg-white border-0" data-testid="order-type-modal">
        <VisuallyHidden><DialogTitle>How would you like your order?</DialogTitle></VisuallyHidden>
        <h2 className="font-heading font-extrabold text-2xl text-center">How would you like your order?</h2>
        <p className="text-sm text-muted-foreground text-center mb-4">Choose delivery or collection to get started.</p>
        <div className="flex flex-col gap-3">
          <button data-testid="choose-delivery" onClick={() => choose("delivery")}
            className="group flex items-center gap-4 p-4 rounded-2xl border-2 border-gray-100 hover:border-metros-red transition-colors text-left">
            <div className="bg-metros-red/10 text-metros-red rounded-xl p-3"><Bike size={26} /></div>
            <div className="flex-1">
              <h3 className="font-heading font-bold text-lg">Delivery</h3>
              <p className="text-sm text-muted-foreground">Get METROS delivered to your door.</p>
            </div>
            <ArrowRight className="text-gray-300 group-hover:text-metros-red group-hover:translate-x-1 transition-transform" />
          </button>
          <button data-testid="choose-collection" onClick={() => choose("collection")}
            className="group flex items-center gap-4 p-4 rounded-2xl border-2 border-gray-100 hover:border-metros-red transition-colors text-left">
            <div className="bg-metros-black/5 text-metros-black rounded-xl p-3"><Store size={26} /></div>
            <div className="flex-1">
              <h3 className="font-heading font-bold text-lg">Collection</h3>
              <p className="text-sm text-muted-foreground">Order ahead and collect from the shop.</p>
            </div>
            <ArrowRight className="text-gray-300 group-hover:text-metros-red group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
